import '../assets/sass/web/_collections.scss'
require('./services/gaService.js')
require('./controller/citySelectController.js')
require('./controller/header.js')
import { getCookie } from './services/cookieService'
var cityName = getCookie("new_prefer_city") ? (getCookie('new_prefer_city').charAt(0).toUpperCase() + getCookie('new_prefer_city').slice(1)) : '';
gaService.addPageView('collections', 'RealEstate', 'Page_' + cityName);